import { render, staticRenderFns } from "./rate-defaultValue-editor.vue?vue&type=template&id=029a8e72&scoped=true&"
import script from "./rate-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./rate-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029a8e72",
  null
  
)

export default component.exports